import React from "react";
import { useLocation } from "react-router-dom";
import "./aboutVideo.css";

const AboutVideo = () => {
  const location = useLocation();
  
  // Check if current page is product details page
  const isProductDetailsPage = location.pathname.startsWith('/product/');

  return (
    <section className="about-video-section">
      <video
        className="about-bg-video"
        src="https://wonder-theme-beauty.myshopify.com/cdn/shop/videos/c/vp/1f37a458867a4bf3926230d69a372666/1f37a458867a4bf3926230d69a372666.HD-1080p-4.8Mbps-8830164.mp4?v=0"
        autoPlay
        loop
        muted
        playsInline
      />

      <div className="about-overlay">
        {isProductDetailsPage ? (
          <>
            <p className="product-details-subtitle">Created In Harmony with Nature</p>
            <h1 className="product-details-title">100% Natural Ingredients</h1>
          </>
        ) : (
          <>
            <h1>About Us</h1>
            <p>Discover Our Story</p>
          </>
        )}
      </div>
    </section>
  );
};

export default AboutVideo;